// src/components/Halls/HallForm.jsx
import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API;

const HallForm = ({ editingHall, onSaved, onCancel }) => {
  const { token } = useAuth();
  
  const [formData, setFormData] = useState({
    name: editingHall?.name || "",
    city: editingHall?.city || "",
    googleMapLink: editingHall?.googleMapLink || "",
    wazeLink: editingHall?.wazeLink || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingHall) {
        await axios.put(`${API}/api/halls/${editingHall._id}`, formData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
        }
        );
        toast.success("האולם עודכן בהצלחה");
      } else {
        await axios.post(`${API}/api/halls`, formData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
        });
        toast.success("האולם נוסף בהצלחה");
      }
      onSaved();
    } catch (err) {
        console.error(err);
        toast.error("שגיאה בשמירת האולם");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="hall-form">
      <label>שם האולם:</label>
      <input
        type="text"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
      />

      <label>ישוב קרוב:</label>
      <input
        type="text"
        name="city"
        value={formData.city}
        onChange={handleChange}
        required
      />

      <label>קישור למפה (Google Maps):</label>
      <input
        type="url"
        name="googleMapLink"
        value={formData.googleMapLink}
        onChange={handleChange}
        placeholder="https://maps.google.com/..."
      />
      <label>קישור למפה (Waze):</label>
      <input
        type="url"
        name="wazeLink"
        value={formData.wazeLink}
        onChange={handleChange}
        placeholder="https://waze.com/..."
      />

      <div className="form-actions">
        <button type="submit" className="save-btn">שמירה</button>
        <button type="button" className="cancel-btn" onClick={onCancel}>
          ביטול
        </button>
      </div>
    </form>
  );
};

export default HallForm;
